<vs-dialog
  [config]="{
    disableBackdropDismiss: submitting,
    dialogContainerClass: 'max-w-[600px]'
  }"
>
  <vs-dialog-header
    [config]="{
      mode: 'simple',
      showDivider: true,
      icon: 'edit-03',
      iconTheme: 'primary',
      title: 'Edit Promo Text',
      subtitle: 'Update the promo text shown to your customers in the portal.'
    }"
  ></vs-dialog-header>
  <form [formGroup]="form" (ngSubmit)="submit()" class="flex flex-col gap-4 p-4">
    <vs-rich-text-editor
      formControlName="promoText"
      placeholder="Enter promo text for your customer portal"
      class="[&_.ck-content]:!min-h-[100px]"
    ></vs-rich-text-editor>
    <div class="flex gap-2 justify-end mt-2">
      <button vs-button appearance="outline" size="sm" type="button" (click)="closeDialog()" [disabled]="submitting">
        Cancel
      </button>
      <button vs-button theme="primary" size="sm" type="submit" [disabled]="submitting">Save</button>
    </div>
  </form>
</vs-dialog>
